/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {IComponentOptions, IFormController} from 'angular';
import RoleUtilService from '../../core/service/RoleUtilService';
import {
    cockpitSelectPrefix,
    getTSCockpitSelectValues,
    TSCockpitSelect
} from '../../models/enums/TSCockpitSelect';
import TSCockpitTypeDTO from '../../models/TSCockpitTypeDTO';
import ErrorService from '../../core/errors/service/ErrorService';
import CockpitRS from '../../core/service/cockpitRS.rest';
import TSCockpitResultDTO from '../../models/TSCockpitResultDTO';
import {TSCockpitType} from '../../models/enums/TSCockpitType';
import ITranslateService = angular.translate.ITranslateService;
import ILogService = angular.ILogService;

declare let require: any;
let template = require('./cockpitView.html');

export class CockpitViewComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = CockpitViewController;
    controllerAs = 'vm';
    bindToController = true;

}

export class CockpitViewController {

    static $inject: string[] = ['$log', 'CONSTANTS', 'RoleUtilService', '$translate', 'ErrorService', 'CockpitRS'];

    public form: IFormController;

    public cockpitTypeDTO: TSCockpitTypeDTO = new TSCockpitTypeDTO();

    public statusDataset = new TSCockpitResultDTO();
    public anzahlGesucheDataset = new TSCockpitResultDTO();
    public gesucheKantonDataset = new TSCockpitResultDTO();
    public gesucheErfassungsArtDataset = new TSCockpitResultDTO();
    public schadenartDataset = new TSCockpitResultDTO();
    public geschaetzteKostenDataset = new TSCockpitResultDTO();
    public neueGesucheDataset = new TSCockpitResultDTO();

    constructor(private $log: ILogService, private CONSTANTS: any, private roleUtilService: RoleUtilService, private $translate: ITranslateService,
                private readonly errorService: ErrorService, private readonly cockpitRS: CockpitRS) {

    }

    $onInit() {
        this.loadCockpitData();
    }

    public translateCockpitSelectForSelect(etv: TSCockpitSelect): string {
        let prefix = cockpitSelectPrefix();
        return this.$translate.instant(prefix + TSCockpitSelect[etv])
    }

    private getTSCockpitSelect(): Array<TSCockpitSelect> {
        return getTSCockpitSelectValues();
    }

    private changedCockpitSelect(): void {
        if (!this.form.$valid) {
            return;
        }

        if (this.cockpitTypeDTO.cockpitSelect === TSCockpitSelect.DATUM_BEREICH && (!this.cockpitTypeDTO.datumVon || !this.cockpitTypeDTO.datumBis)) {
            return;
        }

        if ((this.cockpitTypeDTO.datumVon && this.cockpitTypeDTO.datumBis) &&
            (this.cockpitTypeDTO.datumBis < this.cockpitTypeDTO.datumVon)) {
            this.errorService.addMesageAsError('ERROR_DATE_BEFORE_TO');
            throw new Error(`to cannot be behind from ${this.cockpitTypeDTO.datumVon} > ${this.cockpitTypeDTO.datumBis}`);
        }

        this.loadCockpitData();
    }

    private loadCockpitData() {
        this.cockpitTypeDTO.cockpitType = TSCockpitType.STATUS;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then((response: TSCockpitResultDTO) => {
            this.statusDataset = response;
        });

        this.cockpitTypeDTO.cockpitType = TSCockpitType.GESUCHE_KANTON;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then((response: TSCockpitResultDTO) => {
            this.gesucheKantonDataset = response;
        });

        this.cockpitTypeDTO.cockpitType = TSCockpitType.GESUCHE_ERFASSUNGSART;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then((response: TSCockpitResultDTO) => {
            this.gesucheErfassungsArtDataset = response;
        });

        this.cockpitTypeDTO.cockpitType = TSCockpitType.NEUE_GESUCHE;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then((response: TSCockpitResultDTO) => {
            this.neueGesucheDataset = response;
        });

        this.cockpitTypeDTO.cockpitType = TSCockpitType.SCHADENART;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then((response: TSCockpitResultDTO) => {
            this.schadenartDataset = response;
        });

        this.cockpitTypeDTO.cockpitType = TSCockpitType.GESCHAETZTE_KOSTEN;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then((response: TSCockpitResultDTO) => {
            this.geschaetzteKostenDataset = response;
        });

        this.cockpitTypeDTO.cockpitType = TSCockpitType.ANZAHL_GESUCHE;
        this.cockpitRS.searchCockpitResult(this.cockpitTypeDTO).then((response: TSCockpitResultDTO) => {
            this.anzahlGesucheDataset = response;
        });
    }

    public displayDatum(): boolean | undefined {
        return this.cockpitTypeDTO.cockpitSelect === TSCockpitSelect.DATUM_BEREICH;
    }
}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpitView.ts